import React, { useEffect, useMemo, useRef } from 'react';
import * as echarts from 'echarts';
import styles from "./barGraphwidget.module.css"
import SecondaryTooltip from "../../../../components/secondaryToolTip/secondaryToolTip";
import IMAGES from '../../../../assets/images/images';
import { connect } from 'react-redux';
import { getInternalUserCount } from '../../../../redux/actions/home/home.action';
import { dashboardTime } from '../../../../utils/arrayUtils';
import { WIDGET_NAME } from '../../../../utils/constants/homeConstants';
import Shimmer from '../../../../components/shimmer/Shimmer';
import EmptyDataView from '../../../../components/emptydataview/EmptyDataView';
import { UserManagementTab } from '../../../../utils/constants/userManagementConstant';
import { Link, useNavigate } from 'react-router-dom';
import { setActivePrimaryTab } from '../../../../redux/actions/userManagement/userManagementTab.action';
import { getUTCTimestamp } from '../../../../utils/dateTime';

const BarGraphwidget = ({action,isStack,...props}) => {
  const chartRef = useRef(null);
  const navigate = useNavigate()
  const data = props?.statusWiseInternalUserCount;
  useEffect(()=>{
    if(action===WIDGET_NAME.STATUS_WISE_INTERNAL_USERS_COUNT_WIDGET){
        props?.getInternalUserCount(action)
    }
},[])
const transformedData = useMemo(() => {
  const roles = [], activeUsers = [], inactiveUsers = [];
  const actualActiveUsers = [], actualInactiveUsers = [];
  const zeroUserRoles = [];
  data?.userStatus?.forEach(stat => {
    const roleLabel = stat.roleLabel?.replace("/", "/ ");
    roles.push(roleLabel || "---");
    const active = stat.activeUsers;
    const inactive = stat.inactiveUsers;
    // Store actual values
    actualActiveUsers.push(active);
    actualInactiveUsers.push(inactive);
    // Store visual values (replace 0 with 0.1)
      activeUsers.push(active === 0 ? 0.2 : active);
      inactiveUsers.push(inactive === 0 ? 0.2 : inactive);
      zeroUserRoles.push(active === 0 && inactive === 0);
  });

  return {roles,activeUsers,inactiveUsers,actualActiveUsers,actualInactiveUsers,zeroUserRoles};
}, [data]);

  useEffect(() => {
    if (!chartRef.current) return
    const chart = echarts.init(chartRef.current);
    const totalUsers = transformedData?.actualActiveUsers.map((val, i) => 
      val + transformedData?.actualInactiveUsers[i]
    );

    const labelOption = {
      show: true,
      position: 'top',
      distance: 15,
      align: 'center',
      verticalAlign: 'middle',
      rotate: 0,
      // formatter: '{c}',
      formatter: function (params) {
        return params.value === 0.2 ? '0' : params.value;
      },
      fontFamily:'VodafoneRg-Regular',
      fontSize: 14,
      fontWeight:400,
      rich: {
        name: {}
      }
    };

    const option = {
      tooltip: {
        trigger: 'axis',
        axisPointer: { type: 'shadow' },
        formatter: function (params) {
          let tooltipText = `${params[0].axisValue}<br/>`;
          params.forEach(item => {
            const value = item.value === '-' || item.value === 0.1 || item.value === 0.2 ? 0: item.value;
            tooltipText += `${item.marker} ${item.seriesName}: ${value}<br/>`;
          });
          return tooltipText;
        }
      },
      legend: {
        bottom: '0', // Move legend slightly up from the bottom
        icon: 'circle',
        data: [
          { name: 'Total Users', icon: 'circle' },
          { name: 'Active Users', icon: 'circle' },
          { name: 'Inactive Users', icon: 'circle' },
          // { name: 'Deleted Users', icon: 'circle' }
        ]
      },
      grid: {
        left: '2%',
        right: '2%',
        // top: 60,
        bottom: 40,
        containLabel: true
      },          
      toolbox: {
        show: true,
        orient: 'vertical',
        left: 'right',
        top: 'center',
        feature: {
          mark: { show: true },
        }
      },           
      xAxis: [
        {
          type: 'category',
          axisTick: { show: false },
          data: transformedData?.roles,
          axisLabel: {
            rotate: isStack?"":30, // Tilt x-axis labels by 30 degrees
            interval: 0,
            formatter: function (value) {
              const maxCharsPerLine = 12; // Adjust based on your chart width and font size
              const words = value.split(' ');
              let result = '';
              let line = '';
          
              for (let i = 0; i < words.length; i++) {
                if ((line + words[i]).length <= maxCharsPerLine) {
                  line += words[i] + ' ';
                } else {
                  result += line.trim() + '\n';
                  line = words[i] + ' ';
                }
              }
              result += line.trim(); // Add the last line
              return result;
            }
          }
          
        }
      ],
      yAxis: [{ type: 'value' }],
      series: [
        {
          name: 'Total Users',
          type: 'bar',
          label: labelOption,
          emphasis: { focus: 'series' },
          data: totalUsers.map((value, index) =>
          transformedData?.zeroUserRoles?.[index]? '-': value === 0? 0.2: value),
          // data : totalUsers.map(val => val === 0 ? 0.2 : val),
          // barWidth: 10,
          barGap: '10%',
          itemStyle: {
            color: '#FFE168'
            }
        },
        {
          name: 'Active Users',
          type: 'bar',
          barGap: 0,
          label: labelOption,
          emphasis: { focus: 'series' },
          // data: transformedData?.activeUsers,
          data: transformedData?.activeUsers?.map((value, index) =>
          transformedData?.zeroUserRoles?.[index] ? '-' : value
          ) || [],
          // barWidth: 10,
          barGap: '10%',
          itemStyle: {
            color: '#85E8B3'
            }
        },
        {
          name: 'Inactive Users',
          type: 'bar',
          label: labelOption,
          emphasis: { focus: 'series' },
          // data: transformedData?.inactiveUsers,
          data: transformedData?.inactiveUsers?.map((value, index) =>
          transformedData?.zeroUserRoles?.[index] ? '-' : value
          ) || [],
          // barWidth: 10,
          barGap: '10%',
          itemStyle: {
            color: '#B2B2B2'
            }
        },
        {
          name: 'Zero Users',
          type: 'scatter',
          symbol: 'rect',
          symbolSize: [30, 2],
          silent: true,
          emphasis: { focus: 'series' },
          tooltip: {
            show: false
          },
          itemStyle: {
            color: '#B2B2B2'
          },
          label: {
          show: true,
          position: 'top',
          formatter: '0',
          fontFamily: 'VodafoneRg-Regular',
          fontSize: 14,
          color: '#333333'
          },
          data: transformedData?.zeroUserRoles?.map(isZero =>
            isZero ? 0.1 : '-'
          ) || []
        }
        // {
        // name: 'Zero Users',
        // type: 'scatter',
        // symbolSize: 1,
        // silent: true,
        // tooltip: {
        // show: false
        // },
        // label: {
        // show: true,
        // position: 'top',
        // formatter: '0',
        // fontFamily: 'VodafoneRg-Regular',
        // fontSize: 14,
        // color: '#000'
        // },
        // data: transformedData?.zeroUserRoles?.map((isZero, index) =>
        // isZero ? 0.2 : '-'
        // ) || []
        // }
        // {
        //   name: 'Deleted Users',
        //   type: 'bar',
        //   label: labelOption,
        //   emphasis: { focus: 'series' },
        //   data: transformedData?.deletedUsers,
        //   // barWidth: 10,
        //   barGap: '10%',
        //   itemStyle: {
        //     color: '#FFB2B2'
        //     }
        // }
      ]
    };

    chart.setOption(option);
    const handleResize = () => {
      chart.setOption({
        xAxis: {
          axisLabel: {
            rotate: window.innerWidth < 920 ? 60 : 0
          }
        }
      });
      chart.resize()
    };
    window.addEventListener('resize', handleResize);

    return () => {
      chart.dispose();
      window.removeEventListener('resize', handleResize);
    };
  }, [transformedData, isStack]);

  const handleRetry = (type) => {
    const retryActions = {
    [WIDGET_NAME.STATUS_WISE_INTERNAL_USERS_COUNT_WIDGET]: props.getInternalUserCount,
    };

    const retryFn = retryActions[type];
    if (retryFn) {
    retryFn(type);
    }
};

const gotoDetail = (action) => {
  switch (action) {
    case WIDGET_NAME.STATUS_WISE_INTERNAL_USERS_COUNT_WIDGET:
        return "/user-management/vodafoneUsers";
    default:
        return "#";
  }
}

// const getDetailPayload = (action) => {
//   switch (action) {
//     case WIDGET_NAME.STATUS_WISE_INTERNAL_USERS_COUNT_WIDGET:
//       return {
//         tab: UserManagementTab.VF_GROUP_USER
//       };
//     default:
//       return {};
//   }
// };
const totalUserCount = transformedData?.actualActiveUsers?.reduce((sum, val, i) => {
  return sum + val + (transformedData?.actualInactiveUsers?.[i] || 0);}, 0) || 0;
  
  return (
    <div className={styles.barchartcontainer}>
       <div className={styles.graphheaderwrapper}>
       <div className={styles.graphheader}>User Management - Internal Users</div>
       <div className={styles.wrapparent}>
          <div className={styles.retryparent} onClick={()=>handleRetry(action)}> <div className={styles.retryicon}></div><div className={styles.refresh}>Refresh</div></div>
          <div className={styles.seprator}></div>
          {/* <Link to={`${gotoDetail(action)}/${encodeURIComponent(JSON.stringify(getDetailPayload(action)))}`} target="_blank" rel="noopener noreferrer" className={styles.viewdetailsparent}> <div className={styles.viewdetailicon}></div><div className={styles.detailtext}>View Details</div></Link> */}
          <Link to={`${gotoDetail(action)}`} target="_blank" rel="noopener noreferrer" className={styles.viewdetailsparent}> <div className={styles.viewdetailicon}></div><div className={styles.detailtext}>View Details</div></Link>
      </div>
       </div>
      <div className={styles.graphsubheader}>
        <div className={styles.subheader}>{`Last Updated On: ${dashboardTime(getUTCTimestamp())}`}<SecondaryTooltip text={"The graph below presents data of Internal's users."} positions={['bottom', 'right']}><img className={styles.circleinfo} src={IMAGES.infoCircle}/></SecondaryTooltip></div>
      </div>
      {action===WIDGET_NAME.STATUS_WISE_INTERNAL_USERS_COUNT_WIDGET&&props?.internalUserCountLoading?<div className={styles.shimmerbody}><Shimmer/></div>:
       <>
       {!Array.isArray(data?.userStatus) || data?.userStatus?.length === 0  ? <div className={styles.emptywrapper}><EmptyDataView/></div>:
      <div className={styles.graphbody}>
        <div className={styles.totaluser}>Total: {totalUserCount} users</div>
      <div ref={chartRef} style={{ width: '100%', height: '100%' }} />
      </div>}        
      </>}
    </div>
  )
};

const mapStateToProps = (state) => {
  return {
      statusWiseInternalUserCount:state?.dashBoardCounts?.statusWiseInternalUserCount?.data,
      internalUserCountLoading:state?.dashBoardCounts?.statusWiseInternalUserCount?.isLoading,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getInternalUserCount: (action,) => {
          return dispatch(getInternalUserCount(action,))
    },
    setActivePrimaryTab: (action,) => {
        return dispatch(setActivePrimaryTab(action,))
    },
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(BarGraphwidget);
